import styled from 'styled-components';

import { slate } from '@vimeo/iris/color';
import { Link } from '@vimeo/iris/typography';

export const UserLinkWrapper = styled(Link)<{ isDarkTheme: boolean }>`
  color: ${(props) => (props.isDarkTheme ? 'white' : slate(800))};
  &:hover,
  &:link,
  &:active,
  &:visited {
    color: ${(props) => (props.isDarkTheme ? 'white' : slate(800))} !important;
  }
`;

export const ThumbnailImage = styled.img`
  width: 16px;
  height: 16px;
  border-radius: 50%;
  margin-right: 8px;
  vertical-align: middle;
`;
export const UserName = styled.span`
  vertical-align: middle;
  font-size: 12px;
  font-weight: bold;
  color: inherit;
`;
